import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Button from '../_atomic/Button/Button';
import { publicHash } from '../../utils/constants';
import './MediaUploadProposal.scss';


class MediaUploadProposal extends Component {
  static propTypes = {
    history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
  };

  componentDidMount() {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = () => {
      window.history.go(1);
    };
  }

  clickHandler = ({ to, func }) => {
    func(`${publicHash}/app/${to}`);
  };

  render() {
    const { history: { push } } = this.props;
    const mediaProposalClassNames = classNames(['screen', 'media-proposal-screen']);
    return (
      <div className={mediaProposalClassNames} >
        <div className="media-proposal-content">
          <div className="main-label"><span>Upload Media Files</span></div>
          <div className="table-wrapper">
            <table>
              <tbody>
                <tr>
                  <td>Max amount of files to upload at one time: </td>
                  <td>10 files</td>
                </tr>
                <tr>
                  <td>Max size of 1 file:</td>
                  <td>10 MB for image and 100 MB for video</td>
                </tr>
                <tr>
                  <td>Media files formats: </td>
                  <td />
                </tr>
                <tr>
                  <td>Images:</td>
                  <td>JPEG, JPG, PNG</td>
                </tr>
                <tr>
                  <td>Video:</td>
                  <td>MP4</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="button-wrapper">
            <Button label="Upload Media" clickHandler={() => { this.clickHandler({ to: 'media-upload', func: push }); }} />
          </div>
          <div className="button-wrapper">
            <Button secondary label="Upload Later" clickHandler={() => { this.clickHandler({ to: 'add-payment', func: push }); }} />
          </div>
        </div>
      </div>
    );
  }
}


export default MediaUploadProposal;



// WEBPACK FOOTER //
// ./src/components/MediaUploadProposal/MediaUploadProposal.js